"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateUserCountryBody = exports.OfferwallUserPatchBody = exports.OfferwallUserFE = exports.OfferwallUser = exports.AnonymousAuthBody = void 0;
const zod_1 = require("zod");
const types_1 = require("../../types");
const countryCode_1 = require("../../countryCode");
exports.AnonymousAuthBody = zod_1.z.object({
    deviceInfo: types_1.DeviceInfo,
    subSourceId: zod_1.z.string(),
    /** This field should be null for Playbite users on first launch, otherwise it should be set to the partner's user ID. */
    partnerAppUserId: zod_1.z.string().nullable(),
    age: zod_1.z.number().optional(),
    gender: zod_1.z.string().optional(),
    /** The ad network that the partner app acquired the user from. Must be a string less than 64 characters. */
    partnerAppUANetwork: zod_1.z.string().optional(),
    country: countryCode_1.CountryCodeEnum.nullable(),
});
exports.OfferwallUser = zod_1.z.object({
    id: zod_1.z.string(),
    subSourceId: zod_1.z.string(),
    partnerAppUserId: zod_1.z.string(),
    createdAt: types_1.FTimestamp,
    updatedAt: types_1.FTimestamp,
    coins: zod_1.z.number(),
    email: zod_1.z.string().nullable(),
    lastSessionTime: types_1.FTimestamp,
    IPAddress: zod_1.z.object({
        lastLogin: zod_1.z.string(),
        registration: zod_1.z.string(),
    }),
    lastActivatedOffer: types_1.FTimestamp.nullable(),
    age: zod_1.z.number().nullable().optional(),
    gender: zod_1.z.string().nullable().optional(),
    /** This is the ad network the partner app says they acquired the user from. Must be a string 64 characters or less. */
    partnerAppUANetwork: zod_1.z.string().nullable().optional(),
    country: countryCode_1.CountryCodeEnum.nullable(),
});
exports.OfferwallUserFE = exports.OfferwallUser.omit({
    createdAt: true,
    updatedAt: true,
});
// These are the fields that can be updated by the user's themselves
exports.OfferwallUserPatchBody = exports.OfferwallUser.pick({
    email: true,
}).partial();
exports.UpdateUserCountryBody = zod_1.z.object({
    country: countryCode_1.CountryCodeEnum,
});
